import { Injectable } from "@angular/core";
import { IID_PRATICA_IRU_PROVIDER } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDPraticaIruProviderStore } from "./iidPraticaIruProvider.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.IID_PRATICA_IRU_PROVIDER)
export class IIDPraticaIruProviderQuery extends AbstractInterfaceDataQuery<IID_PRATICA_IRU_PROVIDER> {

  constructor(protected store: IIDPraticaIruProviderStore) {
    super(store);
  }
}
